/* KULT Artikel-Template v1 (23.10.2026) – assets/kult-artikel.js
 * YouTube als Zwei-Klick-Fassade (Startzeit, Kapitel, Zitat-Zeitmarken), Vorher/Nachher-Regler,
 * Inhaltsverzeichnis mit aktivem Abschnitt, Lesefortschritt, „In den Warenkorb“ (öffnet die Impulse-Schublade). */
(function () {
  'use strict';
  if (window.KULT && window.KULT.artikel) return;
  window.KULT = window.KULT || {};
  window.KULT.artikel = true;

  /* ---------- Kopfhöhe (feste Impulse-Kopfzeile) ---------- */
  function kopf() {
    var s = document.querySelector('.site-header--stuck') || document.querySelector('[data-sticky="true"]');
    var h = s ? Math.round(s.getBoundingClientRect().height) : 0;
    var r = document.querySelector('[data-ka]');
    if (r) r.style.setProperty('--ka-top', h + 'px');
  }

  /* ---------- YouTube ---------- */
  function spiele(fig, start) {
    var id = fig.getAttribute('data-ka-yt');
    var src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1&playsinline=1' + (start ? '&start=' + start : '');
    var ifr = fig.querySelector('iframe');
    if (!ifr) {
      ifr = document.createElement('iframe');
      ifr.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      ifr.setAttribute('allowfullscreen', '');
      var b = fig.querySelector('.ka-yt__btn');
      ifr.setAttribute('title', b ? (b.getAttribute('aria-label') || 'Video') : 'Video');
      fig.appendChild(ifr);
    }
    ifr.src = src;
    fig.classList.add('is-an');
  }

  /* ---------- Vorher/Nachher ---------- */
  function vn() {
    document.querySelectorAll('[data-ka-cmp]').forEach(function (c) {
      var r = c.querySelector('.ka-cmp__range');
      if (!r) return;
      r.addEventListener('input', function () { c.style.setProperty('--pos', r.value + '%'); });
    });
  }

  /* ---------- Inhaltsverzeichnis + Lesefortschritt ---------- */
  function toc() {
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-ka-toc]'));
    var ziele = links.map(function (a) { return document.getElementById(a.getAttribute('data-ka-toc')); });
    var bar = document.querySelector('[data-ka-prog]');
    var art = document.querySelector('.ka-main');
    var tick = false;
    function lauf() {
      tick = false;
      var y = 140;
      var aktiv = -1;
      ziele.forEach(function (z, i) { if (z && z.getBoundingClientRect().top - y <= 0) aktiv = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-aktiv', i === aktiv); });
      if (bar && art) {
        var r = art.getBoundingClientRect();
        var g = r.height - window.innerHeight * 0.6;
        var p = g > 0 ? Math.min(1, Math.max(0, -r.top / g)) : 0;
        bar.style.width = (p * 100).toFixed(1) + '%';
      }
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(lauf); } }, { passive: true });
    window.addEventListener('resize', function () { kopf(); lauf(); }, { passive: true });
    lauf();
  }

  /* ---------- Warenkorb ---------- */
  function inDenWarenkorb(btn) {
    var id = parseInt(btn.getAttribute('data-ka-add'), 10);
    if (!id) return;
    var text = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var w = window.KULT && window.KULT.warenkorb;
        return w && w.abgleich ? w.abgleich('hinzugefuegt', true) : null;
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        btn.textContent = 'Hinzugefügt';
        setTimeout(function () { btn.disabled = false; btn.textContent = text; }, 1800);
      })
      .catch(function () { btn.disabled = false; btn.textContent = text; window.location.href = '/cart'; });
  }

  /* ---------- Klicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var yt = t.closest('.ka-yt__btn');
    if (yt) {
      e.preventDefault();
      var f = yt.closest('[data-ka-yt]');
      spiele(f, parseInt(f.getAttribute('data-s'), 10) || 0);
      return;
    }
    var j = t.closest('[data-ka-jump]');
    if (j) {
      var id = j.getAttribute('data-ka-jump');
      var ziel = document.querySelector('[data-ka-yt="' + id + '"]');
      if (ziel) {
        e.preventDefault();
        spiele(ziel, parseInt(j.getAttribute('data-s'), 10) || 0);
        var top = ziel.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(document.querySelector('[data-ka]')).getPropertyValue('--ka-top'), 10) || 0) - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
      return;
    }
    var add = t.closest('[data-ka-add]');
    if (add) { e.preventDefault(); inDenWarenkorb(add); }
  });

  function start() { kopf(); vn(); toc(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
